import React from "react";
import Navbar from "./Navbar";
import Header from "./Header";
import AdminDashCont from "./container/AdminDashCont";
import Footer from "./Footer";
import AdminSchoolData from "../admin-hooks/AdminSchoolData";
import useSidebarToggle from "../hooks/useSidebarToggle";

const AdminDashboard = () => {
    AdminSchoolData();
    useSidebarToggle();
   
    return (
        <div>
            <Navbar />
            <Header />
            <AdminDashCont />
            <Footer />
        </div>
    );
};

export default AdminDashboard;
